function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.333 7A6.67 6.67 0 017 .333 6.669 6.669 0 0113.667 7 6.669 6.669 0 017 13.667 6.669 6.669 0 01.333 7zm2 0l3.334 3.334 6-6-.94-.947-5.06 5.06L3.274 6.06l-.94.94z",
  fill: "#81D89F"
});

function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgCheckCircle;